export default "__VITE_ASSET__DtsgRtC8__"